/** The search (query and filters) each page was last shown with in this tab, so a link back to a list
 * page (a breadcrumb) returns to it as it was left rather than unfiltered. */

const KEY_PREFIX = "perfume.lastSearch:";

export function rememberSearch(pathname: string, search: string): void {
  try {
    window.sessionStorage.setItem(KEY_PREFIX + pathname, search);
  } catch {
    // Storage blocked (private mode): links go to the bare page.
  }
}

/** `to` with the search its page was last shown with, unless `to` names its own. */
export function withLastSearch(to: string): string {
  if (to.includes("?")) return to;
  try {
    return to + (window.sessionStorage.getItem(KEY_PREFIX + to) ?? "");
  } catch {
    return to;
  }
}
